import "./FormHeader.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMultiply, faXmark } from "@fortawesome/pro-regular-svg-icons";
import Button from "../../button/Button";

interface IProps {
    handleClose?: Function;
    name: string;
    description: string;
}

function FormHeader(props: IProps) {
    return (
        <div className="overallHeaderDiv">
            <div className="overallHeaderInnerDiv">
                <h1>{props.name}</h1>
                <p>{props.description}</p>
            </div>
            {props.handleClose && (
                <Button variant="secondary" iconOnly onClick={() => props.handleClose()}>
                    <FontAwesomeIcon icon={faMultiply} />
                </Button>
            )}
        </div>
    );
}

export default FormHeader;
